export default __webpack_public_path__ + "a62791c52ad598cc05f313d485fb18b8.svg";